import { Button, Form, Input, Spin } from 'antd';
import axios from 'axios';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BaseUrlAuth } from '../../../../utils';
import Logo from '../../../general/logo';
import './index.scss';

const formRules: object[] = [
  {
    type: 'email',
    message: 'The input is not valid E-mail!',
  },
  {
    required: true,
    message: 'Please input your E-mail!',
  },
];
const passwordRules: object[] = [
  {
    required: true,
    message: 'Please input your password!',
  },
];

const SignIn: React.FC = ({}): JSX.Element => {
  const [form] = Form.useForm();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const navigation = useNavigate();
  useEffect(() => {
    try {
      setMessage(location.state.message);
    } catch {}
  });
  const [authData, setAuthData] = useState<any>({
    username: '',
    password: '',
  });
  const handleAuthDataChange = (e: any) => {
    setAuthData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleSubmit = () => {
    setIsSubmitted(true);
    axios
      .post(BaseUrlAuth + `/api/v1/auth/jwt/login`, qs.stringify(authData), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((res) => {
        localStorage.setItem('jwt_token', res.data.access_token);
        window.location.href = '/';
        setErrorMessage('');
      })
      .catch((error) => {
        setErrorMessage(
          'The email and/or password you specified are not correct'
        );
        console.log(error);
      })
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  return (
    <div className="signin-page">
      <div style={{ marginTop: '25vh' }}>
        <Logo {...{ size: 'large' }} />
      </div>

      <Form
        form={form}
        name="register"
        onFinish={handleSubmit}
        scrollToFirstError
      >
        <div className="container-xxl signup-container">
          <div className="row">
            <p style={{ color: 'green' }}>{message}</p>
            <div className="col">
              <Form.Item
                className="input-field email"
                name="email"
                label=""
                rules={formRules}
              >
                <Input
                  placeholder="Email"
                  name="username"
                  onChange={handleAuthDataChange}
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Form.Item
                name="password"
                className="input-field"
                label=""
                rules={passwordRules}
              >
                <Input.Password
                  placeholder="Password"
                  className="input-password"
                  name="password"
                  onChange={handleAuthDataChange}
                />
              </Form.Item>
            </div>
          </div>

          <div style={{ marginBottom: '15px', overflow: 'hidden' }}>
            <span
              onClick={() => navigation('/forget-password')}
              style={{ float: 'right', color: '#8CC63E', cursor: 'pointer' }}
            >
              Forgot password
            </span>
          </div>
          <p style={{ color: 'red' }}>{errorMessage}</p>
          {isSubmitted ? (
            <Spin size="large" style={{ margin: '10px' }} />
          ) : (
            <></>
          )}
          <div className="row">
            <div className="col">
              <Form.Item
                className="input-field Sign-Up-Button"
                style={{ paddingTop: '0px', marginBottom: '0px' }}
              >
                <Button type="primary" htmlType="submit">
                  Sign In
                </Button>
              </Form.Item>
            </div>
          </div>
          <p
            style={{
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              color: '#D5D5D5',
              gridColumn: '1/span 2',
            }}
          >
            Do not have an account?{' '}
            <span
              onClick={() => navigation('/signup')}
              style={{
                color: '#8CC63E',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
            >
              {' '}
              Sign Up
            </span>
          </p>
        </div>
      </Form>
    </div>
  );
};

export default SignIn;
